import { render, staticRenderFns } from "./PlatonDatePicker.vue?vue&type=template&id=445a93e7&"
import script from "./PlatonDatePicker.vue?vue&type=script&lang=js&"
export * from "./PlatonDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports